/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { Field, SelectInput } from '@hb/coffee';
import DictApi from '@/api/dict';
import { OptionItem } from '@/model/OptionItem';
import { SupplementInfoField } from '@/components/supplement-info-fields/types';

@Component({ name: 'MaritalStatus' })
export default class MaritalStatus extends Vue implements SupplementInfoField {
  @Prop()
  private value!: undefined | number;

  private maritalStatus: undefined | number | null = null;

  private errorMsg = '';

  private options: OptionItem[] = [];

  private async created() {
    if (this.value) {
      this.maritalStatus = this.value;
    }

    this.options = await DictApi.getMarryTypes();
  }

  @Watch('value')
  private onValueChange(val: undefined | number) {
    if (val !== this.maritalStatus) {
      this.maritalStatus = val;
    }
  }

  public onValidator(): boolean {
    if (this.maritalStatus === undefined || this.maritalStatus === null) {
      this.errorMsg = '请选择婚姻状况';
      return false;
    }

    this.errorMsg = '';
    return true;
  }

  private onChangeMarStatus(val: number | undefined | null) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  private render() {
    return (
      <Field
        label="婚姻状况"
        errorMessage={this.errorMsg}
      >
        <SelectInput
          v-model={this.maritalStatus}
          title="选择婚姻状况"
          placeholder="选择婚姻状况"
          options={this.options}
          optionFieldNames={{
            key: 'code',
            value: 'name',
          }}
          onChange={this.onChangeMarStatus}
        />
      </Field>
    );
  }
}
